'use client';

import { ErrorBoundary } from 'react-error-boundary';

import { useHydrationSafeResponsive } from '~/lib/hooks/useResponsive';

import GenericFallback from './GenericFallback';
import Timeline from './Timeline';

type Props = {
  isStatic?: boolean;
};

const SinglePropertyAside: React.FC<Props> = ({ isStatic }) => {
  const isDesktop = useHydrationSafeResponsive('desktop');

  return (
    isDesktop && (
      <aside className="sticky left-0 z-20 row-start-2 w-svw shrink-0 bg-white text-sm">
        <ErrorBoundary
          fallback={
            <GenericFallback className="m-2 h-14" variant="error" showIcon>
              Error while rendering Timeline
            </GenericFallback>
          }
        >
          <Timeline isStatic={isStatic} />
        </ErrorBoundary>
      </aside>
    )
  );
};

export default SinglePropertyAside;
